var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import uniqWith from "lodash/uniqWith";
export var convertToProduct = function (productDto, masterData, marketplace) {
    var productUnits = __spreadArray([], masterData.productUnits, true);
    var taxes = __spreadArray([], marketplace.taxes, true);
    return {
        id: productDto.id,
        uuid: productDto.uuid,
        category: productDto.product_category && __assign({}, productDto.product_category),
        size: productDto.unit_amount ? {
            unit: productUnits.find(function (unit) { return unit.id === productDto.unit_id; }),
            amount: productDto.unit_amount,
        } : undefined,
        sku: productDto.sku,
        name: productDto.name,
        description: productDto.description,
        brand: productDto.brand,
        manufacturer: productDto.manofacturer,
        code: productDto.barcode,
        imageUrl: (productDto.business_product && productDto.business_product.image_url) ? productDto.business_product.image_url : productDto.photo_url,
        metadata: productDto.metadata,
        price: productDto.price,
        bestseller: productDto.bestseller,
        createdFromScratch: productDto.created_from_scratch,
        active: productDto.active,
        vendors: (productDto.sells && productDto.vendors) ? productDto.sells.map(function (sell) {
            var vendor = productDto.vendors.find(function (vendor) { return vendor.id === sell.vendor_id; });
            return {
                id: sell.id,
                uuid: sell.uuid,
                cost: Number(sell.cost),
                default: sell.default,
                vendor: {
                    id: vendor.id,
                    uuid: vendor.uuid,
                    contact: vendor.contact_name,
                    deleted: vendor.deleted,
                    email: vendor.email,
                    name: vendor.name,
                    phone: vendor.phone,
                    website: vendor.website
                },
            };
        }) : [],
        businessProduct: productDto.business_product && {
            id: productDto.business_product.id,
            uuid: productDto.business_product.uuid,
            name: productDto.business_product.name,
            description: productDto.business_product.description,
            code: productDto.business_product.barcode,
            brand: productDto.business_product.brand,
            manufacturer: productDto.business_product.manofacturer,
            size: productDto.business_product.unit_id ? {
                unit: productUnits.find(function (unit) { return unit.id === productDto.business_product.unit_id; }),
                amount: productDto.business_product.unit_amount,
            } : undefined,
            availableForCheckout: productDto.business_product.available_for_checkout,
            pricing: {
                price: productDto.business_product.price,
                taxes: taxes
                    .filter(function (tax) { return (productDto.business_product.tax_ids || []).includes(tax.id); })
                    .map(function (tax) { return (__assign({}, tax)); }),
            },
            stock: productDto.business_product.stock,
            alert: productDto.alert,
            imageUrl: productDto.business_product.image_url,
            destroyable: productDto.business_product.destroyable,
        },
    };
};
export var convertToLookupProduct = function (lookupProductsDto) {
    var cuddlesProducts = lookupProductsDto.products
        .map(function (product) { return ({
        id: product.id,
        code: product.barcode,
        name: product.name || "",
        imageUrl: product.photo_url
    }); })
        .sort(function (product, otherProduct) { return product.name.localeCompare(otherProduct.name); });
    var products = uniqWith(lookupProductsDto.more_results
        .map(function (product) { return ({
        name: product.title || "",
        code: product.barcode,
        imageUrl: product.photo_url,
    }); })
        .filter(function (product) { return !cuddlesProducts.some(function (p) { return p.code === product.code; }); }), function (product, otherProduct) { return product.code === otherProduct.code; }).sort(function (product, otherProduct) { return product.name.localeCompare(otherProduct.name); });
    var result = __spreadArray(__spreadArray([], cuddlesProducts, true), products, true);
    return result;
};
